import { Box, ProgressBar, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import InformationButton from '../InformationButton'
import SummaryBox from '../SummaryBox'

interface Props {
  title: string
  tooltipInformation: string
  totalAmount: number
  currentAmount: number
  onClick: () => void
}

const progressColor = (currentAmount: number, totalAmount: number) => {
  const percentage = (currentAmount / totalAmount) * 100

  if (percentage === 100) {
    return 'viridian1200'
  }

  if (percentage > 50) {
    return 'champagne1000'
  }

  return 'radicalRed1000'
}

const SummaryProgressBarBox = ({
  title,
  tooltipInformation,
  totalAmount,
  currentAmount,
  onClick,
}: Props) => {
  const percentage = (currentAmount / totalAmount) * 100

  return (
    <SummaryBox
      title={title}
      styles={{
        border: { right: { color: 'grey400', style: 'solid', width: 's1' } },
        paddingRight: 's24',
      }}
    >
      <Box flexDirection="row" alignItems="center" justifyContent="spaceBetween" gap="s8">
        <Box flexDirection="row" alignItems="center" justifyContent="center" gap="s4">
          <Text.Header2 color="grey1000">{currentAmount}</Text.Header2>
          <Text.Normal color="grey800" size="300" weight="normal">
            /
          </Text.Normal>
          <Text.Normal color="grey800" size="300" weight="normal">
            {totalAmount}
          </Text.Normal>
        </Box>

        {currentAmount < totalAmount && (
          <InformationButton tooltipLabel={tooltipInformation} onClick={onClick} />
        )}
      </Box>
      <Box width="s96">
        <ProgressBar
          amount={currentAmount}
          total={totalAmount}
          progressColor={progressColor(currentAmount, totalAmount)}
          barColor={percentage > 50 ? 'champagne400' : 'radicalRed200'}
        />
      </Box>
    </SummaryBox>
  )
}

export default observer(SummaryProgressBarBox)
